module.exports = __webpack_public_path__ + "img/icon_qiatan.da15a884.png";